




























































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Types
import { IMetaData } from "@/models/metaData";

@Component
export default class MetaDataForm extends Mixins(HasValidation) {
  // Props

  @Prop({ required: true })
  public value!: IMetaData;

  @Prop({ required: true })
  public metaData!: IMetaData;

  @Prop({ required: true })
  public isDisabled!: IMetaData;

  // Data

  public metaDataArray: IMetaData = [];

  // Life-cycle methods

  public created() {
    this.metaDataArray = _.map(this.metaData, (value, key) => {
      return { key, value };
    });
    this.metaDataArray.push({ key: "", value: "" });
  }

  // Methods

  public remove(data) {
    this.metaDataArray = _.filter(
      this.metaDataArray,
      metaData => metaData.key !== data.key
    );
  }

  public checkRows() {
    const emptyRows = _.filter(
      this.metaDataArray,
      data => data.key === "" && data.value === ""
    );

    if (emptyRows.length === 1) return;
    if (emptyRows.length > 1)
      this.metaDataArray = _.filter(
        this.metaDataArray,
        data => data.key !== "" || data.value !== ""
      );

    this.metaDataArray.push({ key: "", value: "" });
  }

  public keyRules(index) {
    const keys: string[] = [];

    _.forEach(
      this.metaDataArray,
      (data: { key: string; value: string }, count) => {
        if (index !== count && data.key !== "") keys.push(data.key);
      }
    );

    return {
      is_not_multiple: keys,
      required: this.metaDataArray.length > index + 1
    };
  }

  public async save() {
    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      this.$emit("save");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
  }

  // Computed

  public get metaDataForm() {
    const form = {};
    _.forEach(this.metaDataArray, metaData => {
      if (metaData.key !== "" && metaData.value !== "")
        form[metaData.key] = metaData.value;
    });
    return form;
  }

  public get formIsChanged() {
    return !this.$_.isEqual(this.metaDataForm, this.metaData || {});
  }

  // Watchers

  @Watch("metaDataForm")
  public onMetaDataFormChange() {
    this.$emit("input", this.metaDataForm);
  }

  @Watch("hasErrors")
  public onHasErrorChange() {
    this.$emit("hasErrors", this.hasErrors);
  }

  @Watch("formIsChanged")
  public onFormIsChangedChange() {
    this.$emit("formIsChanged", this.formIsChanged);
  }
}
